import React, { useRef, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import '../../web-components/modal-lgpd';

const ModalLgpd = ({ open, onClick }) => {
  const [show, setShow] = useState(open);
  const modalRef = useRef();

  useEffect(() => {
    setShow(open);
  }, [open, setShow]);

  useEffect(() => {
    const elementRef = modalRef.current;
    const handleEvent = e => {
      e.preventDefault();
      setShow(false);
      onClick(e);
    };

    elementRef.addEventListener(
      'ok',
      e => {
        handleEvent(e);
      },
      false
    );

    return () =>
      elementRef.removeEventListener(
        'ok',
        e => {
          handleEvent(e);
        },
        false
      );
  }, [show, onClick]);

  const modal = <modal-lgpd show={show} ref={modalRef} />;
  return createPortal(modal, document.body);
};

export default ModalLgpd;
